function normalizeMedicalValueContext(value: string): string {
  return value
    .toLowerCase()
    .replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const FAMILY_HISTORY_RELATION_PATTERN =
  /\b(family|familial|relative|relatives|parent|parents|mother|father|mom|dad|sibling|siblings|brother|sister|grandparent|grandparents|grandmother|grandfather|aunt|uncle|cousin)\b/;

const FAMILY_HISTORY_MEDICAL_PATTERN =
  /\b(gestational|gdm|lada|type\s*1|type\s*i|t1d|t1dm|type\s*2|type\s*ii|t2d|t2dm|diabetes|dm|insulin\s+resistance|insulin\s+resistant|ir|pcos|polycystic\s+ovary|hashimoto|hyperthyroid|overactive|hypothyroid|underactive|thyroid)\b/;

export function isFamilyHistoryMedicalValue(value: string): boolean {
  const normalized = normalizeMedicalValueContext(value);
  if (!normalized || !FAMILY_HISTORY_MEDICAL_PATTERN.test(normalized)) return false;

  return (
    FAMILY_HISTORY_RELATION_PATTERN.test(normalized) ||
    /\bfamily\s+history\b/.test(normalized) ||
    /\bin\s+parent\s+s\b/.test(normalized)
  );
}

export function isPcosWorkupReference(value: string): boolean {
  const normalized = normalizeMedicalValueContext(value);
  if (!normalized) return false;

  const mentionsPcos =
    /\bpcos\b/.test(normalized) ||
    /\bpolycystic\s+ovary\b/.test(normalized);
  const mentionsWorkup = /\b(workup|work\s+up)\b/.test(normalized);

  return mentionsPcos && mentionsWorkup;
}
